import { render, staticRenderFns } from "./PluginIntro.vue?vue&type=template&id=1cacf40e&scoped=true"
import script from "./PluginIntro.vue?vue&type=script&lang=js"
export * from "./PluginIntro.vue?vue&type=script&lang=js"
import style0 from "./PluginIntro.vue?vue&type=style&index=0&id=1cacf40e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cacf40e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cacf40e')) {
      api.createRecord('1cacf40e', component.options)
    } else {
      api.reload('1cacf40e', component.options)
    }
    module.hot.accept("./PluginIntro.vue?vue&type=template&id=1cacf40e&scoped=true", function () {
      api.rerender('1cacf40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginIntro.vue"
export default component.exports